import { ChartSource } from "./chart";

export type DeviceType = "Sensor" | "Actuator";

export interface DeviceChartConfig {
    source: ChartSource;
    filterFn: (device: any) => boolean;
    defaultName: string;
    displayName: string;
    displayNamePlural: string;
    displayNameLower: string;
}

export const DEVICE_CHART_CONFIG: Record<DeviceType, DeviceChartConfig> = {
    Sensor: {
        source: ChartSource.MULTIPLE_SENSORS,
        filterFn: (device: any) => !device.isActuator,
        defaultName: "Multiple sensor chart",
        displayName: "Sensor",
        displayNamePlural: "Sensors",
        displayNameLower: "sensor",
    },
    Actuator: {
        source: ChartSource.MULTIPLE_ACTUATORS,
        filterFn: (device: any) => device.isActuator,
        defaultName: "Multiple actuator chart",
        displayName: "Actuator",
        displayNamePlural: "Actuators",
        displayNameLower: "actuator",
    },
} as const;
